import React, { Component } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper
} from '@material-ui/core/';


import EditAddressDialog, { DEFAULT_ADDRESS } from '../dialogs/EditAddressDialog'
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import EnhancedTableToolbar from '@apricityhealth/web-common-lib/components/EnhancedTableToolbar';

class AddressView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: props.address || [],
            modalOpen: false,
            editIndex:0,
            create:false
        }
    }

    handleAdd() {
        const { address } = this.state;
        address.push(DEFAULT_ADDRESS);
        this.setState({ modalOpen: true, editIndex: address.length - 1, address });
    }

    handleEdit(i)  {
        this.setState({editIndex: i, modalOpen:true})
    }

    handleDelete(e, i)  {
        if (e){
            e.stopPropagation();
            e.preventDefault();
        }
        const { address } = this.state;
        address.splice( i, 1 );
        this.setState({ address });
    }

    componentDidUpdate(prevProps){
        if (JSON.stringify(prevProps.address) !== JSON.stringify(this.props.address)){
            this.setState({address: this.props.address});
        }
    }

    render(){
        const { address, modalOpen, editIndex } = this.state;
        const { appContext } = this.props;

        let addresses = () => {
            var tableRows = []
            if (Array.isArray(address)){
                address.forEach( (a, i)=> {
                    var row = (
                        <TableRow
                            hover
                            onClick={() => this.handleEdit(i)}
                            tabIndex={i}
                            key={i}
                        >
                            <TableCell>
                                {a.addressType}
                            </TableCell>
                            <TableCell>
                                {a.street1}
                            </TableCell>
                            <TableCell>
                                {a.street2}
                            </TableCell>
                            <TableCell>
                                {a.city}
                            </TableCell>
                            <TableCell>
                                {a.state}
                            </TableCell>
                            <TableCell>
                                {a.postalCode}
                            </TableCell>
                            <TableCell>
                                {a.country}
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    aria-label="Delete"
                                    onClick={(e) => this.handleDelete(e, i)} >
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    )
                    tableRows.push(row)
                })
            }
            return tableRows 
        }
        const editCreateModal = () => {
            if (! modalOpen ) return null;

            return <EditAddressDialog 
                address={address[editIndex]}
                appContext={appContext}
                onDone={(a) => {
                    address[editIndex] = a;
                    this.setState({ modalOpen: false, address })
                }}
                onCancel={() => this.setState({modalOpen: false})}
                onDelete={() => {
                    address.splice( editIndex, 1);
                    this.setState({ modalOpen: false, address })
                }} />;
        }
        
        return (
            <div>
                {editCreateModal()}
                <Paper>
                <EnhancedTableToolbar
                    title='Addresses'
                    onAdd={() => this.handleAdd() }
                    numSelected={0}
                />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell>Street 1</TableCell>
                            <TableCell>Street 2</TableCell>
                            <TableCell>City</TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>Postal Code</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Delete</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {addresses()}
                    </TableBody>
                </Table>
                </Paper>
            </div>
        )
    }
}

export default AddressView;